export function PaymentTestModeBanner() {
  // Disabled — payments are live.
  return null;
}
